{
  "about.blocks": "Servijerioù evezhiet",
  "about.contact": "Darempred :",
  "about.default_locale": "Dre ziouer",
  "about.domain_blocks.no_reason_available": "Abeg dihegerz",
  "about.domain_blocks.preamble": "Gant Mastodon e c'hellit gwelet danvez hag eskemm gant implijerien·ezed eus forzh peseurt servijer er fedibed peurliesañ. Setu an nemedennoù a zo bet graet evit ar servijer-mañ e-unan.",
  "about.domain_blocks.silenced.explanation": "Ne vo ket gwelet profiloù eus ar servijer-mañ ganeoc'h peurliesañ, nemet ma vefec'h o klask war o lec'h pe choazfec'h o heuliañ.",
  "about.domain_blocks.silenced.title": "Bevennet",
  "about.domain_blocks.suspended.explanation": "Roadenn ebet eus ar servijer-mañ ne vo keweriet, kadavet pe eskemmet, ar pezh a lako an etreweriañ pe ar c'hehentiñ gant implijerien·ezed adalek ar servijer-mañ dibosupl.",
  "about.domain_blocks.suspended.title": "Astalet",
  "about.language_label": "Yezh",
  "about.not_available": "An titour-mañ ne c'heller ket gwelet war ar servijer-mañ.",
  "about.powered_by": "Rouedad sokial digreizenned kaset gant {mastodon}",
  "about.rules": "Reolennoù ar servijer",
  "account.account_note_header": "Notenn bersonel",
  "account.activity": "Obererezh",
  "account.add_note": "Ouzhpennañ un notenn hiniennel",
  "account.add_or_remove_from_list": "Ouzhpenn pe dilemel eus al listennadoù",
  "account.badges.admin": "Merour",
  "account.badges.blocked": "Stanket",
  "account.badges.bot": "Robot",
  "account.badges.domain_blocked": "Domani stanket",
  "account.badges.group": "Strollad",
  "account.badges.muted": "Kuzhet",
  "account.badges.muted_until": "Kuzhet betek {until}",
  "account.block": "Stankañ @{name}",
  "account.block_domain": "Stankañ an domani {domain}",
  "account.block_short": "Stankañ",
  "account.blocked": "Stanket",
  "account.cancel_follow_request": "Nullañ ar reked heuliañ",
  "account.copy": "Eilañ al liamm war-zu ho profil",
  "account.direct": "Menegiñ @{name} ent-prevez",
  "account.disable_notifications": "Paouez d'am c'hemenn pa vez embannet traoù gant @{name}",
  "account.edit_note": "Kemmañ un notent hiniennel",
  "account.edit_profile": "Kemmañ ar profil",
  "account.edit_profile_short": "Kemmañ",
  "account.enable_notifications": "Ma c'hemenn pa vez embannet traoù gant @{name}",
  "account.endorse": "Lakaat en a-raok war ar profil",
  "account.familiar_followers_one": "Heuliet gant {name1}",
  "account.familiar_followers_two": "Heuliet gant {name1} ha {name2}",
  "account.featured": "En a-raok",
  "account.featured.accounts": "Profiloù",
  "account.featured.collections": "Dastumadegoù",
  "account.featured.new_collection": "Dastumadeg nevez",
  "account.field_overflow": "Diskouez pep tra",
  "account.filters.all": "An holl obererezhioù",
  "account.filters.boosts_toggle": "Diskouez ar skignadennoù",
  "account.filters.posts_only": "Embannadurioù",
  "account.filters.posts_replies": "Embannadurioù ha respontoù",
  "account.filters.replies_toggle": "Diskouez ar respontoù",
  "account.follow": "Heuliañ",
  "account.follow_back": "Heuliañ d'ho tro",
  "account.follow_back_short": "Heuliañ d'ho tro",
  "account.follow_request": "Reked d'ho heuliañ",
  "account.follow_request_cancel": "Nullañ ar reked",
  "account.follow_request_cancel_short": "Nullañ",
  "account.followers": "Tud koumanantet",
  "account.followers.empty": "Den na heul an implijer·ez-mañ c'hoazh.",
  "account.followers_counter": "{count, plural, one {{counter} heulier} two {{counter} heulier} few {{counter} heulier} many {{counter} heulier} other {{counter} heulier}}",
  "account.followers_you_know_counter": "{counter} a anavezit",
  "account.following": "Koumanantoù",
  "account.follows.empty": "An implijer·ez-mañ na heul den ebet.",
  "account.follows_you": "Ho heuilh",
  "account.go_to_profile": "Gwelet ar profil",
  "account.hide_reblogs": "Kuzh skignadennoù gant @{name}",
  "account.in_memoriam": "E koun.",
  "account.join_modal.day": "Deiz",
  "account.join_modal.years": "{number, plural, two {vloavezh} many {a vloavezhioù} other {bloavezh}}",
  "account.joined_short": "Amañ abaoe",
  "account.languages": "Cheñch ar yezhoù koumanantet",
  "account.last_active": "Oberiantiz zivezhañ",
  "account.link_verified_on": "Gwiriet eo bet perc'hennidigezh al liamm d'an deiziad-mañ : {date}",
  "account.locked_info": "Prennet eo ar gont-mañ. Gant ar perc'henn e vez dibabet piv a c'hall heuliañ anezhi pe anezhañ.",
  "account.media": "Media",
  "account.mention": "Menegiñ @{name}",
  "account.menu.add_to_collection": "Ouzhpennañ d'an dastumadeg…",
  "account.menu.add_to_list": "Ouzhpennañ d'al listenn…",
  "account.menu.block": "Stankañ ar gont",
  "account.menu.block_domain": "Stankañ {domain}",
  "account.menu.copy": "Eilañ al liamm",
  "account.menu.mute": "Kuzhat ar gont",
  "account.menu.share": "Rannañ…",
  "account.menu.unblock": "Distankañ ar gont",
  "account.menu.unblock_domain": "Distankañ {domain}",
  "account.menu.unmute": "Diguzhat ar gont",
  "account.moved_to": "Gant {name} eo bet merket e oa bremañ h·e gont nevez :",
  "account.mute": "Kuzhat @{name}",
  "account.mute_notifications_short": "Kuzhat ar c'hemennoù",
  "account.mute_short": "Kuzhat",
  "account.muted": "Kuzhet",
  "account.mutual": "Heuliañ a rit an eil egile",
  "account.no_bio": "Deskrivadur ebet da gaout.",
  "account.node_modal.save": "Enrollañ",
  "account.open_original_page": "Digeriñ ar bajenn orin",
  "account.posts": "Embannadurioù",
  "account.remove_from_followers": "Dilemel {name} eus an heulierien·ezed",
  "account.report": "Disklêriañ @{name}",
  "account.requested_follow": "Gant {name} eo bet goulennet ho heuliañ",
  "account.share": "Skignañ profil @{name}",
  "account.show_reblogs": "Diskouez skignadennoù @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} embannadur} two {{counter} embannadur} few {{counter} embannadur} many {{counter} embannadur} other {{counter} embannadur}}",
  "account.unblock": "Distankañ @{name}",
  "account.unblock_domain": "Distankañ an domani {domain}",
  "account.unblock_domain_short": "Distankañ",
  "account.unblock_short": "Distankañ",
  "account.unendorse": "Na lakaat ket en a-raok war ar profil",
  "account.unfollow": "Diheuliañ",
  "account.unmute": "Diguzhat @{name}",
  "account.unmute_notifications_short": "Diguzhat ar c'hemennoù",
  "account.unmute_short": "Diguzhat",
  "account_edit.field_edit_modal.name_hint": "Da skouer \"lec'hienn web personel\"",
  "account_edit.image_delete_modal.delete_button": "Dilemel",
  "account_edit.image_delete_modal.title": "Dilemel ar skeudenn ?",
  "account_edit.image_edit.add_button": "Ouzhpennañ ur skeudenn",
  "account_edit.image_edit.remove_button": "Dilemel ar skeudenn",
  "account_edit.item_list.delete": "Dilemel {name}",
  "account_edit.item_list.edit": "Cheñch {name}",
  "account_edit.save": "Enrollañ",
  "account_edit.upload_modal.back": "Distreiñ",
  "account_edit.upload_modal.step_upload.header": "Dibab ur skeudenn",
  "account_edit_tags.suggestions": "Kinnigoù :",
  "admin.dashboard.daily_retention": "Feur azdalc'h an implijerien·ezed dre zeiz goude bezañ lakaet o anv",
  "admin.dashboard.monthly_retention": "Feur azdalc'h an implijerien·ezed dre viz goude bezañ lakaet o anv",
  "admin.dashboard.retention.average": "Keidenn",
  "admin.dashboard.retention.cohort": "Miz an enrolladur",
  "admin.dashboard.retention.cohort_size": "Implijerien·ezed nevez",
  "admin.impact_report.instance_accounts": "Profiloù kontoù a vefe dilamet",
  "admin.impact_report.instance_followers": "Heulierien a gollfe hon implijerien·ezed",
  "admin.impact_report.instance_follows": "Heulierien a gollfe o implijerien·ezed",
  "alert.rate_limited.message": "Klaskit en-dro a-benn {retry_time, time, medium}.",
  "alert.rate_limited.title": "Feur bevennet",
  "alert.unexpected.message": "Ur fazi dic'hortozet zo degouezhet.",
  "alert.unexpected.title": "Hopala !",
  "alt_text_badge.title": "Eiltestenn",
  "alt_text_modal.add_alt_text": "Ouzhpennañ un eiltestenn",
  "alt_text_modal.cancel": "Nullañ",
  "alt_text_modal.change_thumbnail": "Kemmañ ar velvenn",
  "alt_text_modal.done": "Graet",
  "announcement.announcement": "Kemennad",
  "annual_report.nav_item.badge": "Nevez",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.close": "Serriñ",
  "annual_report.summary.most_used_app.most_used_app": "arload muiañ implijet",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "ar gerioù-klik implijet ar muiañ",
  "annual_report.summary.new_posts.new_posts": "embannadurioù nevez",
  "annual_report.summary.share_on_mastodon": "Rannañ war Mastodon",
  "attachments_list.unprocessed": "(ket meret)",
  "audio.hide": "Kuzhat ar c'hleved",
  "block_modal.show_less": "Diskouez nebeutoc'h",
  "block_modal.show_more": "Diskouez muioc'h",
  "block_modal.title": "Stankañ an implijer·ez?",
  "boost_modal.combo": "Ar wezh kentañ e c'halliot gwaskañ war {combo} evit tremen hebiou",
  "boost_modal.reblog": "Skignañ an embannadur?",
  "boost_modal.undo_reblog": "Paouez da skignañ an embannadur?",
  "bundle_column_error.copy_stacktrace": "Eilañ an danevell fazi",
  "bundle_column_error.error.body": "N'haller ket skrammañ ar bajenn goulennet. Gallout a ra bezañ abalamour d'ur beug er c'hod pe d'ur gudenn keverlec'hded gant ar merdeer.",
  "bundle_column_error.error.title": "Chaous !",
  "bundle_column_error.network.body": "Degouezhet ez eus bet ur fazi en ur glask kargañ ar bajenn-mañ. Gallout a rafe bezañ abalamour d'ur gudenn padennek pe abalamour d'ar servijer-mañ.",
  "bundle_column_error.network.title": "Fazi rouedad",
  "bundle_column_error.retry": "Klask en-dro",
  "bundle_column_error.return": "Distreiñ d'an degemer",
  "bundle_column_error.routing.body": "N'haller ket kavout ar bajenn goulennet. Sur oc'h eo reizh an URL er varrenn chomlec'hioù?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Serriñ",
  "bundle_modal_error.retry": "Klask en-dro",
  "closed_registrations.other_server_instructions": "Peogwir ez eo Mastodon digreizennet e c'heller krouiñ ur gont war ur servijer all ha kenderc'hel da zaremprediñ gant hemañ.",
  "closed_registrations_modal.description": "N'eo ket posupl krouiñ ur gont war {domain} evit ar mare, met n'ho peus ket ezhomm ur gont war {domain} dre ret evit ober gant Mastodon.",
  "closed_registrations_modal.find_another_server": "Kavout ur servijer all",
  "closed_registrations_modal.preamble": "Digreizennet eo Mastodon, forzh pelec'h e vefe krouet ho kont e viot gouest da heuliañ hag etreweriañ gant an holl war ar servijer-mañ. Gallout a rit herbec'hiañ anezhañ hoc'h-unan zoken!",
  "closed_registrations_modal.title": "Enskrivadurioù war Mastodon",
  "collections.block_collection_owner": "Stankañ ar gont",
  "collections.by_account": "gant {account_handle}",
  "collections.collection_description": "Deskrivadur",
  "collections.collection_language": "Yezh",
  "collections.collection_name": "Anv",
  "collections.continue": "Kenderc'hel",
  "collections.remove_account": "Dilemel",
  "collections.share_short": "Rannañ",
  "column.about": "Diwar-benn",
  "column.blocks": "Implijerien·ezed stanket",
  "column.bookmarks": "Sinedoù",
  "column.community": "Red-amzer lec'hel",
  "column.create_list": "Krouiñ ul listenn",
  "column.direct": "Menegoù prevez",
  "column.directory": "Mont a-dreuz ar profiloù",
  "column.domain_blocks": "Domani stanket",
  "column.edit_list": "Kemmañ al listenn",
  "column.favourites": "Muiañ-karet",
  "column.firehose": "Redoù war-eeun",
  "column.follow_requests": "Rekedoù heuliañ",
  "column.home": "Degemer",
  "column.lists": "Listennoù",
  "column.mutes": "Implijerien·ezed kuzhet",
  "column.notifications": "Kemennoù",
  "column.pins": "Embannadurioù spilhennet",
  "column.public": "Red-amzer kevredet",
  "column_back_button.label": "Distreiñ",
  "column_header.hide_settings": "Kuzhat an arventennoù",
  "column_header.moveLeft_settings": "Dilec'hiañ ar bannad a-gleiz",
  "column_header.moveRight_settings": "Dilec'hiañ ar bannad a-zehou",
  "column_header.pin": "Spilhennañ",
  "column_header.show_settings": "Diskouez an arventennoù",
  "column_header.unpin": "Dispilhennañ",
  "column_search.cancel": "Nullañ",
  "combobox.loading": "O kargañ",
  "community.column_settings.local_only": "Nemet lec'hel",
  "community.column_settings.media_only": "Nemet Mediaoù",
  "community.column_settings.remote_only": "Nemet a-bell",
  "compose.language.change": "Cheñch yezh",
  "compose.language.search": "Klask yezhoù...",
  "compose.published.body": "Embannet.",
  "compose.published.open": "Digeriñ",
  "compose.saved.body": "Enrollet.",
  "compose_form.direct_message_warning_learn_more": "Gouzout hiroc'h",
  "compose_form.encryption_warning": "Embannadurioù war Mastodon na vezont ket sifret a-benn-da-benn. Na rannit ket titouroù kizidik dre Mastodon.",
  "compose_form.hashtag_warning": "Ne vo ket listennet an embannadur-mañ dindan gerioù-klik ebet dre m'eo anlistennet. N'eus nemet an embannadurioù foran a c'hall bezañ klasket dre c'her-klik.",
  "compose_form.lock_disclaimer": "N'eo ket {locked} ho kont. An holl a c'hal ho heuliañ evit gwelet hoc'h embannadurioù prevez.",
  "compose_form.lock_disclaimer.lock": "prennet",
  "compose_form.placeholder": "Petra emaoc'h o soñjal e-barzh ?",
  "compose_form.poll.duration": "Pad ar sontadeg",
  "compose_form.poll.multiple": "Meur a choaz",
  "compose_form.poll.option_placeholder": "Choaz {number}",
  "compose_form.poll.switch_to_multiple": "Kemmañ ar sontadeg evit aotren meur a zibab",
  "compose_form.poll.switch_to_single": "Kemmañ ar sontadeg evit aotren un dibab hepken",
  "compose_form.poll.type": "Neuz",
  "compose_form.publish": "Embann",
  "compose_form.reply": "Respont",
  "compose_form.save_changes": "Hizivadur",
  "compose_form.spoiler.marked": "Kuzhet eo an destenn a-dreñv ur c'hemenn",
  "compose_form.spoiler.unmarked": "N'eo ket kuzhet an destenn",
  "confirmation_modal.cancel": "Nullañ",
  "confirmations.block.confirm": "Stankañ",
  "confirmations.delete.confirm": "Dilemel",
  "confirmations.delete.message": "Ha sur oc'h e fell deoc'h dilemel an embannadur-mañ?",
  "confirmations.delete.title": "Dilemel an embannadur?",
  "confirmations.delete_collection.confirm": "Dilemel",
  "confirmations.delete_collection.title": "Dilemel \"{name}\" ?",
  "confirmations.delete_list.confirm": "Dilemel",
  "confirmations.delete_list.message": "Ha sur eo hoc'h eus c'hoant da zilemel ar roll-mañ da vat ?",
  "confirmations.delete_list.title": "Dilemel al listenn?",
  "confirmations.discard_draft.confirm": "Diverkañ ha kenderc'hel",
  "confirmations.discard_draft.edit.cancel": "Distreiñ d'an embann",
  "confirmations.discard_draft.post.cancel": "Distreiñ d'ar brouilhed",
  "confirmations.discard_draft.post.title": "Dilemel ho prouilhed?",
  "confirmations.discard_edit_media.confirm": "Nac'hañ",
  "confirmations.discard_edit_media.message": "Bez ez eus kemmoù n'int ket enrollet e deskrivadur ar media pe ar rakwel, nullañ anezho evelato?",
  "confirmations.follow_to_list.confirm": "Heuliañ hag ouzhpennañ d'al listenn",
  "confirmations.follow_to_list.title": "Heuliañ an implijer·ez?",
  "confirmations.hide_featured_tab.confirm": "Kuzhat an ivinell",
  "confirmations.logout.confirm": "Digevreañ",
  "confirmations.logout.message": "Ha sur oc'h e fell deoc'h digevreañ ?",
  "confirmations.logout.title": "Digevreañ?",
  "confirmations.missing_alt_text.confirm": "Ouzhpennañ un eiltestenn",
  "confirmations.missing_alt_text.secondary": "Embann memes tra",
  "confirmations.missing_alt_text.title": "Ouzhpennañ an eiltestenn?",
  "confirmations.mute.confirm": "Kuzhat",
  "confirmations.quiet_post_quote_info.got_it": "Mat eo",
  "confirmations.redraft.confirm": "Diverkañ ha skrivañ en-dro",
  "confirmations.redraft.title": "Diverkañ ha skrivañ an embann en-dro?",
  "confirmations.remove_from_followers.confirm": "Dilemel an heulier·ez",
  "confirmations.remove_from_followers.title": "Dilemel an heulier·ez?",
  "confirmations.revoke_quote.confirm": "Dilemel an embannadur",
  "confirmations.revoke_quote.title": "Dilemel an embannadur?",
  "confirmations.unblock.confirm": "Distankañ",
  "confirmations.unblock.title": "Distankañ {name}?",
  "confirmations.unfollow.confirm": "Diheuliañ",
  "confirmations.unfollow.title": "Diheuliañ {name}?",
  "confirmations.withdraw_request.confirm": "Nullañ ar reked",
  "confirmations.withdraw_request.title": "Nullañ ho reked da heuliañ {name}?",
  "content_warning.hide": "Kuzhat an embannadur",
  "content_warning.show": "Diskwel memes tra",
  "content_warning.show_more": "Diskouez muioc'h",
  "content_warning.show_short": "Diskouez",
  "conversation.delete": "Dilemel ar gaozeadenn",
  "conversation.mark_as_read": "Merkañ evel lennet",
  "conversation.open": "Gwelet ar gaozeadenn",
  "conversation.with": "Gant {names}",
  "copy_icon_button.copied": "Eilet er golver",
  "copypaste.copied": "Eilet",
  "copypaste.copy_to_clipboard": "Eilañ er golver",
  "directory.federated": "Eus ar fedibed anavezet",
  "directory.local": "Eus {domain} hepken",
  "directory.new_arrivals": "Degouezhet a-nevez",
  "directory.recently_active": "Oberiant nevez zo",
  "disabled_account_banner.account_settings": "Arventennoù ar gont",
  "disabled_account_banner.text": "Ho kont {disabledAccount} zo divev evit bremañ.",
  "dismissable_banner.community_timeline": "Setu embannadurioù foran nevesañ an dud a zo herberc’hiet o c’hontoù gant {domain}.",
  "dismissable_banner.dismiss": "Diverkañ",
  "domain_block_modal.block": "Stankañ ar servijer",
  "domain_block_modal.block_account_instead": "Stankañ @{name} kentoc'h",
  "domain_block_modal.title": "Stankañ an domani?",
  "dropdown.empty": "Diuzit un dibarzh",
  "email_subscriptions.email": "Postel",
  "email_subscriptions.form.action": "Koumanantiñ",
  "embed.instructions": "Enframmit an embannadur-mañ en ho lec’hienn en ur eilañ ar c’hod amañ-dindan.",
  "embed.preview": "Setu penaos e teuio war wel :",
  "emoji_button.activity": "Obererezh",
  "emoji_button.clear": "Diverkañ",
  "emoji_button.custom": "Personelaet",
  "emoji_button.flags": "Bannieloù",
  "emoji_button.food": "Boued & Evajoù",
  "emoji_button.label": "Enlakaat un emoji",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Emoji ebet !! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Traoù",
  "emoji_button.people": "Tud",
  "emoji_button.recent": "Implijet alies",
  "emoji_button.search": "O klask...",
  "emoji_button.search_results": "Disoc'hoù an enklask",
  "emoji_button.symbols": "Arouezioù",
  "emoji_button.travel": "Beajiñ & Lec'hioù",
  "empty_column.account_suspended": "Kont astalet",
  "empty_column.account_timeline": "Embannadur ebet amañ!",
  "empty_column.account_unavailable": "Profil dihegerz",
  "empty_column.blocks": "N'eus ket bet stanket implijer·ez ganeoc'h c'hoazh.",
  "empty_column.bookmarked_statuses": "N'ho peus embannadur ebet enrollet en ho sinedoù c'hoazh. Pa vo ouzhpennet unan e teuio war wel amañ.",
  "empty_column.community": "Goulo eo ar red-amzer lec'hel. Skrivit'ta un dra evit lakaat tan dezhi !",
  "empty_column.domain_blocks": "N'eus domani stanket ebet c'hoazh.",
  "empty_column.explore_statuses": "N'eus tuadur ebet evit c'hoazh. Distroit diwezhatoc'h !",
  "empty_column.follow_requests": "N'ho peus reked heuliañ ebet c'hoazh. Pa vo resevet unan e teuio war wel amañ.",
  "empty_column.followed_tags": "N'emaoc'h oc'h heuliañ ger-klik ebet evit poent. Pa vioc'h e vo d'o gwelet amañ.",
  "empty_column.hashtag": "N'eus netra er ger-klik-mañ c'hoazh.",
  "empty_column.home": "Goullo eo ho red-amzer degemer! Kit da weladenniñ {public} pe implijit ar c'hlask evit kregiñ ganti ha kejañ gant implijer·ien·ezed all.",
  "empty_column.list": "Goullo eo al listenn-mañ evit c'hoazh. Pa vo embannet un dra nevez gant e izili e teuio war wel amañ.",
  "empty_column.mutes": "N'ho peus kuzhet implijer·ez ebet c'hoazh.",
  "empty_column.notifications": "N'ho peus kemenn ebet c'hoazh. Grit gant implijer·ezed·ien all evit loc'hañ ar gomz.",
  "empty_column.public": "N'eus netra amañ! Skrivit un dra bennak foran pe heuilhit implijerien·ezed eus servijerioù all evit leuniañ",
  "error.unexpected_crash.explanation": "Abalamour d'ur beug en hor c'hod pe d'ur gudenn geverlec'hded n'hallomp ket skrammañ ar bajenn-mañ en un doare dereat.",
  "error.unexpected_crash.explanation_addons": "Ar bajenn-mañ ne c'hell ket bezañ skrammet mat. Ar fazi-se a zo kaoz d'un astenn pe d'un ostilh troidigezh emgefreek war ho merdeer.",
  "error.unexpected_crash.next_steps": "Klaskit azbevaat ar bajenn. Ma n'a ket en-dro e c'hallit klask ober gant Mastodon dre ur merdeer disheñvel pe dre an arload genidik.",
  "error.unexpected_crash.next_steps_addons": "Klaskit azbevaat ar bajenn. Ma n'ez a ket en-dro e c'hallit klask ober gant Mastodon dre ur merdeer disheñvel pe dre an arload genidik.",
  "errors.unexpected_crash.copy_stacktrace": "Eilañ ar roudoù diveugañ er golver",
  "errors.unexpected_crash.report_issue": "Danevellañ ur fazi",
  "explore.suggested_follows": "Tud",
  "explore.title": "Diouzh ar c'hiz",
  "explore.trending_links": "Keleier",
  "explore.trending_statuses": "Embannadurioù",
  "explore.trending_tags": "Gerioù-klik",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions.add": "Ouzhpennañ",
  "filter_modal.added.context_mismatch_title": "Kenarroud digenglotus !",
  "filter_modal.added.expired_title": "Sil deuet d'e dermen !",
  "filter_modal.added.review_and_configure_title": "Arventennoù ar sil",
  "filter_modal.added.settings_link": "pajenn an arventennoù",
  "filter_modal.added.short_explanation": "Ouzhpennet eo bet an embannadur-mañ d'ar rummad sil-mañ: {title}.",
  "filter_modal.added.title": "Sil ouzhpennet !",
  "filter_modal.select_filter.context_mismatch": "na glot ket gant ar c'henarroud-mañ",
  "filter_modal.select_filter.expired": "zo deuet d'e dermen",
  "filter_modal.select_filter.prompt_new": "Rummad nevez : {name}",
  "filter_modal.select_filter.search": "Klask pe krouiñ",
  "filter_modal.select_filter.subtitle": "Implijout ur rummad a zo anezhañ pe krouiñ unan nevez",
  "filter_modal.select_filter.title": "Silañ an embannadur-mañ",
  "filter_modal.title.status": "Silañ un embannadur",
  "filter_warning.matches_filter": "A glot gant ar sil “<span>{title}</span>”",
  "firehose.all": "Pep tra",
  "firehose.local": "Ar servijer-mañ",
  "firehose.remote": "Servijerioù all",
  "follow_request.authorize": "Aotren",
  "follow_request.reject": "Nac'hañ",
  "follow_requests.unlocked_explanation": "Daoust ma n'eo ket ho kont prennet, skipailh {domain} a soñj e fellfe deoc'h gwiriekaat pedadennoù heuliañ deus ar c'hontoù-se diwar-zorn.",
  "follow_suggestions.dismiss": "Na ziskouez ket ken",
  "follow_suggestions.friends_of_friends_longer": "Diouzh ar c'hiz e-touez an dud heuliet ganeoc'h",
  "follow_suggestions.popular_suggestion_longer": "Diouzh ar c'hiz war {domain}",
  "follow_suggestions.view_all": "Gwelet pep tra",
  "follow_suggestions.who_to_follow": "Piv heuliañ",
  "followed_tags": "Gerioù-klik heuliet",
  "following.title": "Heuliet gant {name}",
  "footer.about": "Diwar-benn",
  "footer.about_mastodon": "Diwar-benn Mastodon",
  "footer.about_server": "Diwar-benn {domain}",
  "footer.about_this_server": "Diwar-benn",
  "footer.directory": "Kavlec'h ar profiloù",
  "footer.get_app": "Pellgargañ an arload",
  "footer.keyboard_shortcuts": "Berradennoù klavier",
  "footer.privacy_policy": "Reolennoù prevezded",
  "footer.source_code": "Gwelet ar c'hod mammenn",
  "footer.status": "Statud",
  "footer.terms_of_service": "Divizoù implijout hollek",
  "getting_started.heading": "Loc'hañ",
  "hashtag.admin_moderation": "Digeriñ an etrefas evezhiañ evit #{name}",
  "hashtag.browse": "Furchal dre an embannadurioù gant #{hashtag}",
  "hashtag.browse_from_account": "Furchal dre an embannadurioù gant @{name} gant #{hashtag}",
  "hashtag.column_header.tag_mode.all": "ha(g) {additional}",
  "hashtag.column_header.tag_mode.any": "pe {additional}",
  "hashtag.column_header.tag_mode.none": "hep {additional}",
  "hashtag.column_settings.select.no_options_message": "N'eus bet kavet ali ebet",
  "hashtag.column_settings.select.placeholder": "Ouzhpennañ gerioù-klik…",
  "hashtag.column_settings.tag_mode.all": "An holl anezho",
  "hashtag.column_settings.tag_mode.any": "Unan e mesk anezho",
  "hashtag.column_settings.tag_mode.none": "Hini ebet anezho",
  "hashtag.column_settings.tag_toggle": "Endelc'her gerioù-alc'hwez ouzhpenn evit ar bannad-mañ",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} embannadur} other {{counter} embannadur}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} embannadur} other {{counter} embannadur}} hiziv",
  "hashtag.feature": "Lakaat en a-raok war ar profil",
  "hashtag.follow": "Heuliañ ar ger-klik",
  "hashtag.mute": "Kuzhat #{hashtag}",
  "hashtag.unfeature": "Na lakaat ket en a-raok war ar profil",
  "hashtag.unfollow": "Diheuliañ ar ger-klik",
  "hashtags.and_other": "…{count, plural, one {hag # all} other {ha # all}}",
  "hints.profiles.see_more_posts": "Gwelet embannadurioù ouzhpenn eus {domain}",
  "home.column_settings.show_quotes": "Diskouez an arroudennoù",
  "home.column_settings.show_reblogs": "Diskouez ar skignadennoù",
  "home.column_settings.show_replies": "Diskouez ar respontoù",
  "home.hide_announcements": "Kuzhat ar c'hemennoù",
  "home.pending_critical_update.body": "Hizivait ho servijer Mastodon kerkent ha ma c'hallit mar plij!",
  "home.pending_critical_update.link": "Gwelet an hizivadennoù",
  "home.show_announcements": "Diskouez ar c'hemennoù",
  "info_button.label": "Skoazell",
  "interaction_modal.go": "Mont di",
  "interaction_modal.no_account_yet": "N'ho peus ket ur gont c'hoazh?",
  "interaction_modal.on_another_server": "War ur servijer all",
  "interaction_modal.on_this_server": "War ar servijer-mañ",
  "interaction_modal.title": "Kevreañ evit kenderc'hel",
  "interaction_modal.username_prompt": "D.s. {example}",
  "intervals.full.days": "{number, plural, one {# devezh} other{# a zevezhioù}}",
  "intervals.full.hours": "{number, plural, one {# eurvezh} other{# eurvezh}}",
  "intervals.full.minutes": "{number, plural, one {# munut} other{# a vunutoù}}",
  "keyboard_shortcuts.back": "Distreiñ",
  "keyboard_shortcuts.blocked": "Digeriñ roll an implijerien·ezed stanket",
  "keyboard_shortcuts.boost": "Skignañ an embannadur",
  "keyboard_shortcuts.column": "Fokus ar bann",
  "keyboard_shortcuts.compose": "Fokus an takad testenn",
  "keyboard_shortcuts.description": "Deskrivadur",
  "keyboard_shortcuts.down": "Diskennañ er roll",
  "keyboard_shortcuts.enter": "Digeriñ an embannadur",
  "keyboard_shortcuts.favourite": "Ouzhpennañ an embannadur d'ar re vuiañ-karet",
  "keyboard_shortcuts.favourites": "Digeriñ roll an embannadurioù muiañ-karet",
  "keyboard_shortcuts.federated": "Digeriñ ar red-amzer kevredet",
  "keyboard_shortcuts.heading": "Berradennoù klavier",
  "keyboard_shortcuts.home": "Digeriñ ho red-amzer degemer",
  "keyboard_shortcuts.hotkey": "Berradur",
  "keyboard_shortcuts.legend": "Skrammañ ar skrid-se",
  "keyboard_shortcuts.local": "Digeriñ red-amzer lec'hel",
  "keyboard_shortcuts.mention": "Menegiñ an aozer.ez",
  "keyboard_shortcuts.muted": "Digeriñ roll an implijerien·ezed kuzhet",
  "keyboard_shortcuts.my_profile": "Digeriñ ho profil",
  "keyboard_shortcuts.notifications": "Digeriñ bann ar c'hemennoù",
  "keyboard_shortcuts.open_media": "Digeriñ ar media",
  "keyboard_shortcuts.pinned": "Digeriñ listenn an embannadurioù spilhennet",
  "keyboard_shortcuts.profile": "Digeriñ profil an aozer.ez",
  "keyboard_shortcuts.quote": "Menegiñ an embannadur",
  "keyboard_shortcuts.reply": "Respont d'an embannadur",
  "keyboard_shortcuts.requests": "Digeriñ roll goulennoù heuliañ",
  "keyboard_shortcuts.search": "Fokus barenn klask",
  "keyboard_shortcuts.spoilers": "da guzhat/ziguzhat tachenn CW",
  "keyboard_shortcuts.start": "Digeriñ bann \"Kregiñ\"",
  "keyboard_shortcuts.toggle_hidden": "da guzhat/ziguzhat an desten a-dreñv CW",
  "keyboard_shortcuts.toggle_sensitivity": "da guzhat/ziguzhat ur media",
  "keyboard_shortcuts.toot": "Kregiñ gant un embannadur nevez",
  "keyboard_shortcuts.unfocus": "Difokus an dachenn testenn/klask",
  "keyboard_shortcuts.up": "Pignat er roll",
  "learn_more_link.got_it": "Mat eo",
  "learn_more_link.learn_more": "Gouzout hiroc'h",
  "lightbox.close": "Serriñ",
  "lightbox.next": "Da-heul",
  "lightbox.previous": "A-raok",
  "limited_account_hint.action": "Diskouez ar profil memes tra",
  "link_preview.author": "Gant {name}",
  "link_preview.more_from_author": "Muioc'h gant {name}",
  "link_preview.shares": "{count, plural, one {{counter} embannadur} two {{counter} embannadur} few {{counter} embannadur} many {{counter} embannadur} other {{counter} embannadur}}",
  "lists.add_member": "Ouzhpennañ",
  "lists.add_to_list": "Ouzhpennañ d'al listenn",
  "lists.create": "Krouiñ",
  "lists.create_a_list_to_organize": "Krouit ul listenn evit renkañ ho red degemer",
  "lists.create_list": "Krouiñ ul listenn",
  "lists.delete": "Dilemel al listenn",
  "lists.done": "Graet",
  "lists.edit": "Kemmañ al listenn",
  "lists.list_name": "Anv al listenn",
  "lists.new_list_name": "Anv nevez al listenn",
  "lists.no_lists_yet": "Listenn ebet c'hoazh.",
  "lists.remove_member": "Dilemel",
  "lists.replies_policy.followed": "Pep implijer·ez heuliet",
  "lists.replies_policy.list": "Izili ar roll",
  "lists.replies_policy.none": "Den ebet",
  "lists.save": "Enrollañ",
  "lists.search": "Klask",
  "load_pending": "{count, plural, one {# dra nevez} other {# dra nevez}}",
  "loading_indicator.label": "O kargañ…",
  "media_gallery.hide": "Kuzhat",
  "mute_modal.hide_from_notifications": "Kuzhat er c'hemennoù",
  "mute_modal.hide_options": "Dibarzhioù ar c'huzhat",
  "mute_modal.show_options": "Dibarzhioù an diskwel",
  "mute_modal.title": "Kuzhat an implijer·ez?",
  "navigation_bar.about": "Diwar-benn",
  "navigation_bar.account_settings": "Ger-tremen ha surentez",
  "navigation_bar.administration": "Merañ",
  "navigation_bar.automated_deletion": "Dilemel an embannadenn ent-emgefreek",
  "navigation_bar.blocks": "Implijerien·ezed stanket",
  "navigation_bar.bookmarks": "Sinedoù",
  "navigation_bar.direct": "Menegoù prevez",
  "navigation_bar.domain_blocks": "Domanioù stanket",
  "navigation_bar.favourites": "Muiañ-karet",
  "navigation_bar.filters": "Gerioù kuzhet",
  "navigation_bar.follow_requests": "Rekedoù heuliañ",
  "navigation_bar.followed_tags": "Gerioù-klik heuliet",
  "navigation_bar.follows_and_followers": "Heuliadennoù ha heulier·ezed·ien",
  "navigation_bar.import_export": "Enporzhiañ hag ezporzhiañ",
  "navigation_bar.lists": "Listennoù",
  "navigation_bar.live_feed_local": "Red war-eeun (lec'hel)",
  "navigation_bar.live_feed_public": "Red war-eeun (foran)",
  "navigation_bar.logout": "Digevreañ",
  "navigation_bar.moderation": "Habaskadur",
  "navigation_bar.more": "Muioc'h",
  "navigation_bar.mutes": "Implijerien·ezed kuzhet",
  "navigation_bar.preferences": "Gwellvezioù",
  "navigation_bar.search": "Klask",
  "navigation_bar.search_trends": "Klask / Diouzh ar c'hiz",
  "not_signed_in_indicator.not_signed_in": "Ret eo deoc'h kevreañ evit tizhout an danvez-se.",
  "notification.admin.report": "Disklêriet eo bet {target} gant {name}",
  "notification.admin.sign_up": "{name} en·he deus lakaet e·hec'h anv",
  "notification.favourite": "Gant {name} eo bet ouzhpennet hoc'h embannadur d'h·e re vuiañ-karet",
  "notification.follow": "heuliañ a ra {name} ac'hanoc'h",
  "notification.follow.name_and_others": "{name} <a>{count, plural, one {hag # den all} two {ha # zen all} few {ha # den all} many {ha # den all} other {ha # den all}}</a> zo o heuliañ ac'hanoc'h",
  "notification.follow_request": "Gant {name} eo bet goulennet ho heuliañ",
  "notification.label.quote": "Gant {name} eo bet meneget hoc'h embannadur",
  "notification.label.reply": "Respont",
  "notification.mention": "Meneg",
  "notification.mentioned_you": "Gant {name} oc'h bet meneget",
  "notification.moderation-warning.learn_more": "Gouzout hiroc'h",
  "notification.moderation_warning.action_disable": "Diweredekaet eo bet ho kont.",
  "notification.moderation_warning.action_suspend": "Astalet eo bet ho kont.",
  "notification.own_poll": "Echu eo ho sontadeg",
  "notification.quoted_update": "Gant {name} eo bet kemmet un embannadur meneget ganeoc'h",
  "notification.reblog": "Gant {name} eo bet skignet hoc'h embannadur",
  "notification.relationships_severance_event.learn_more": "Gouzout hiroc'h",
  "notification.status": "Emañ {name} o paouez embann",
  "notification.update": "Gant {name} ez eus bet kemmet un embannadur",
  "notification_requests.accept": "Asantiñ",
  "notification_requests.dismiss": "Diverkañ",
  "notification_requests.edit_selection": "Kemmañ",
  "notification_requests.exit_selection": "Graet",
  "notifications.clear": "Skarzhañ ar c'hemennoù",
  "notifications.clear_confirmation": "Ha sur oc'h e fell deoc'h skarzhañ ho holl kemennoù ?",
  "notifications.column_settings.admin.report": "Disklêriadurioù nevez :",
  "notifications.column_settings.admin.sign_up": "Enskrivadurioù nevez :",
  "notifications.column_settings.alert": "Kemennoù war ar burev",
  "notifications.column_settings.favourite": "Muiañ-karet:",
  "notifications.column_settings.filter_bar.advanced": "Diskouez an holl rummadoù",
  "notifications.column_settings.follow": "Heulierien nevez:",
  "notifications.column_settings.follow_request": "Rekedoù heuliañ nevez:",
  "notifications.column_settings.group": "Strollañ",
  "notifications.column_settings.mention": "Menegoù:",
  "notifications.column_settings.poll": "Disoc'hoù ar sontadeg:",
  "notifications.column_settings.push": "Kemennoù push",
  "notifications.column_settings.quote": "Menegoù:",
  "notifications.column_settings.reblog": "Skignadennoù:",
  "notifications.column_settings.show": "Diskouez er bann",
  "notifications.column_settings.sound": "Seniñ",
  "notifications.column_settings.status": "Embannadurioù nevez:",
  "notifications.column_settings.unread_notifications.category": "Kemennoù anlennet",
  "notifications.column_settings.unread_notifications.highlight": "Uslinennañ ar c'hemennoù anlennet",
  "notifications.column_settings.update": "Kemmoù:",
  "notifications.filter.all": "Pep tra",
  "notifications.filter.boosts": "Skignadennoù",
  "notifications.filter.favourites": "Muiañ-karet",
  "notifications.filter.follows": "Heuliañ",
  "notifications.filter.mentions": "Menegoù",
  "notifications.filter.polls": "Disoc'hoù ar sontadegoù",
  "notifications.filter.statuses": "Hizivadurioù eus tud heuliet ganeoc'h",
  "notifications.grant_permission": "Reiñ aotre.",
  "notifications.group": "{count} a gemennoù",
  "notifications.mark_as_read": "Merkañ an holl kemennoù evel bezañ lennet",
  "notifications.permission_denied": "Kemennoù war ar burev n'int ket hegerz rak pedadenn aotren ar merdeer a zo bet nullet araok",
  "notifications.permission_denied_alert": "Kemennoù war ar burev na c'hellont ket bezañ lezelet, rak aotre ar merdeer a zo bet nac'het a-raok",
  "notifications.permission_required": "Kemennoù war ar burev n'int ket hegerz abalamour d'an aotre rekis n'eo ket bet roet.",
  "notifications.policy.accept": "Asantiñ",
  "notifications.policy.accept_hint": "Diskouez er c’hemennoù",
  "notifications.policy.drop": "Tremen e-bioù",
  "notifications.policy.filter": "Silañ",
  "notifications.policy.filter_new_accounts_title": "Kontoù nevez",
  "notifications.policy.filter_not_followers_title": "Tud na heuliont ket ac'hanoc'h",
  "notifications.policy.filter_not_following_title": "Tud n'int ket heuliet ganeoc'h",
  "notifications_permission_banner.enable": "Lezel kemennoù war ar burev",
  "notifications_permission_banner.how_to_control": "Evit reseviñ kemennoù pa ne vez ket digoret Mastodon, lezelit kemennoù war ar burev. Gallout a rit kontrollañ peseurt eskemmoù a c'henel kemennoù war ar burev gant ar {icon} nozelenn a-us kentre ma'z int lezelet.",
  "notifications_permission_banner.title": "Na vankit netra morse",
  "onboarding.follows.back": "Distreiñ",
  "onboarding.follows.search": "Klask",
  "onboarding.profile.display_name": "Anv diskouezet",
  "onboarding.profile.display_name_hint": "Hoc'h anv klok pe hoc'h anv fentus…",
  "onboarding.profile.finish": "Echuiñ",
  "onboarding.profile.note": "Berr-ha-berr",
  "onboarding.profile.note_hint": "Gallout a rit @menegiñ tud all pe #gerioù-klik…",
  "onboarding.profile.title": "Kefluniañ ar profil",
  "onboarding.profile.upload_avatar": "Enporzhiañ ur skeudenn profil",
  "password_confirmation.mismatching": "Disheñvel eo an daou c'her-termen-se",
  "picture_in_picture.restore": "Adlakaat",
  "poll.closed": "Serret",
  "poll.refresh": "Azbevaat",
  "poll.reveal": "Gwelet an disoc'hoù",
  "poll.total_people": "{count, plural, one {# den} other {# a zen}}",
  "poll.total_votes": "{count, plural, one {# votadenn} other {# votadenn}}",
  "poll.vote": "Mouezhiañ",
  "poll.voted": "Mouezhiet ho peus evit ar respont-mañ",
  "poll.votes": "{votes, plural,one {#votadenn} other {# votadenn}}",
  "poll_button.add_poll": "Ouzhpennañ ur sontadeg",
  "poll_button.remove_poll": "Dilemel ar sontadeg",
  "privacy.change": "Cheñch prevezded an embannadur",
  "privacy.direct.long": "Pep hini meneget en embannadur",
  "privacy.private.long": "Hoc'h heulierien·ezed hepken",
  "privacy.private.short": "Heulierien",
  "privacy.public.short": "Publik",
  "privacy.quote.disabled": "{visibility}, menegoù diweredekaet",
  "privacy_policy.last_updated": "Hizivadenn ziwezhañ {date}",
  "privacy_policy.title": "Reolennoù Prevezded",
  "quote_error.poll": "N'haller ket menegiñ sontadegoù.",
  "recommended": "Erbedet",
  "refresh": "Freskaat",
  "regeneration_indicator.preparing_your_home_feed": "O prientiñ ho red degemer…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# devezh} two {# zevezh} few {# devezh} many {# a devezh} other {# devezh}} zo",
  "relative_time.full.hours": "{number, plural, one {# eurvezh} two {# eurvezh} few {# eurvezh} many {# eur} other {# eurvezh}} zo",
  "relative_time.full.just_now": "bremañ",
  "relative_time.full.minutes": "{number, plural, one {# munut} two {# vunut} few {# munut} many {# munut} other {# munut}} zo",
  "relative_time.full.seconds": "{number, plural, one {# eilenn} two {# eilenn} few {# eilenn} many {# eilenn} other {# eilenn}} zo",
  "relative_time.hours": "{number}e",
  "relative_time.just_now": "bremañ",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}eil",
  "relative_time.today": "hiziv",
  "remove_quote_hint.button_label": "Mat eo",
  "remove_quote_hint.title": "Fellout a ra deoc'h dilemel ho menegiñ an embannadur?",
  "reply_indicator.cancel": "Nullañ",
  "reply_indicator.poll": "Sontadeg",
  "report.block": "Stankañ",
  "report.block_explanation": "Ne vo ket gwelet embannadurioù ar gont-se ken. Ne welo ket hoc'h embannadurioù ha ne c'hello ket ho heuliañ ken. Gouzout a raio eo bet stanket ganeoc'h.",
  "report.categories.legal": "Lezennel",
  "report.categories.other": "All",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Torret e vez gant an endalc'had unan pe meur a reolenn",
  "report.category.subtitle": "Choazit ar pezh a glot ar gwellañ",
  "report.close": "Graet",
  "report.comment.title": "Ha traoù all a rankfemp gouzout ?",
  "report.forward": "Treuzkas da: {target}",
  "report.forward_hint": "War ur servijer all emañ ar c'hont-se. Kas dezhañ un adskrid disanv eus an danevell ivez?",
  "report.mute": "Kuzhat",
  "report.mute_explanation": "Ne vo ket gwelet embannadurioù ar gont-se ken. Gwelet hoc'h embannadurioù ha ho heuliañ a c'hello ha ne ouezo ket eo bet kuzhet ganeoc'h.",
  "report.next": "War-raok",
  "report.placeholder": "Askelennoù ouzhpenn",
  "report.reasons.dislike": "Ne blij ket din",
  "report.reasons.dislike_description": "An dra-se na fell ket deoc'h gwelet",
  "report.reasons.legal": "Enep al lezenn eo",
  "report.reasons.other": "Un abeg all eo",
  "report.reasons.other_description": "Ar gudenn na glot ket gant ar rummadoù all",
  "report.reasons.spam": "Spam eo",
  "report.reasons.spam_description": "Liammoù gwallyoulet, engouestl faos, respontoù liezek",
  "report.reasons.violation": "Terriñ a ra reolennoù ar servijer",
  "report.reasons.violation_description": "Gouzout a rit e ya a-enep da reolennoù ar servijer",
  "report.rules.subtitle": "Diuzit an holl draoù a glot",
  "report.rules.title": "Pesort reolennoù zo bet torret ?",
  "report.statuses.subtitle": "Diuzit an holl draoù a glot",
  "report.statuses.title": "Hag embannadurioù all zo a c'hallfe nerzhañ an disklêriadenn-se?",
  "report.submit": "Kinnig",
  "report.target": "O tisklêriañ {target}",
  "report.thanks.title": "Ne fell ket deoc'h gwelet an dra-se ?",
  "report.thanks.title_actionable": "Trugarez evit bezañ disklêriet, emaomp o vont da glask pelloc'h.",
  "report.unfollow": "Diheuliañ @{name}",
  "report_notification.attached_statuses": "{count, plural, one {{count} embannadur} other {{count} embannadur}} stag",
  "report_notification.categories.legal": "Lezennel",
  "report_notification.categories.other": "All",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Torradur da reolennoù ar servijer",
  "report_notification.open": "Digeriñ an disklêriadur",
  "search.no_recent_searches": "Klask nevez ebet",
  "search.placeholder": "Klask",
  "search.quick_action.account_search": "Profiloù a glot gant {x}",
  "search.quick_action.go_to_account": "Mont d'ar profil {x}",
  "search.quick_action.go_to_hashtag": "Mont d'ar ger-klik {x}",
  "search.quick_action.open_url": "Digeriñ an URL e-barzh Mastodon",
  "search.quick_action.status_search": "Toudoù a glot gant {x}",
  "search.search_or_paste": "Klask pe pegañ un URL",
  "search_popout.full_text_search_disabled_message": "N'eo ket da gaout war {domain}.",
  "search_popout.language_code": "Kod yezh ISO",
  "search_popout.options": "Dibarzhioù klask",
  "search_popout.quick_actions": "Oberoù prim",
  "search_popout.recent": "Klaskoù nevesañ",
  "search_popout.specific_date": "deiziad resis",
  "search_popout.user": "implijer·ez",
  "search_results.accounts": "Profiloù",
  "search_results.all": "Pep tra",
  "search_results.hashtags": "Gerioù-klik",
  "search_results.no_results": "Disoc'h ebet.",
  "search_results.see_all": "Gwelet pep tra",
  "search_results.statuses": "Toudoù",
  "server_banner.active_users": "implijerien·ezed oberiant",
  "server_banner.administered_by": "Meret gant :",
  "server_banner.server_stats": "Stadegoù ar servijer :",
  "sign_in_banner.create_account": "Krouiñ ur gont",
  "sign_in_banner.sign_in": "Kevreañ",
  "sign_in_banner.sso_redirect": "Kevreañ pe lakaat hoc'h anv",
  "status.admin_account": "Digeriñ etrefas evezhiañ evit @{name}",
  "status.admin_domain": "Digeriñ an etrefas evezhiañ evit {domain}",
  "status.admin_status": "Digeriñ an embannadenn e-barzh an etrefas evezhiañ",
  "status.all_disabled": "Diweredekaet eo ar skignañ hag ar menegiñ",
  "status.block": "Stankañ @{name}",
  "status.bookmark": "Ouzhpennañ d'ar sinedoù",
  "status.cancel_reblog_private": "Nac'hañ ar skignadenn",
  "status.cannot_reblog": "Ar c'hannad-se na c'hall ket bezañ skignet",
  "status.context.show": "Diskouez",
  "status.copy": "Eilañ liamm ar c'hannad",
  "status.delete": "Dilemel",
  "status.delete.success": "Embannadur dilamet",
  "status.detailed_status": "Gwel kaozeadenn munudek",
  "status.direct": "Menegiñ @{name} ent-prevez",
  "status.direct_indicator": "Meneg prevez",
  "status.edit": "Kemmañ",
  "status.edited": "Kemmet da ziwezhañ d'an {date}",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.favourite": "Muiañ-karet",
  "status.filter": "Silañ ar c'hannad-mañ",
  "status.history.created": "Krouet gant {name} {date}",
  "status.history.edited": "Kemmet gant {name} {date}",
  "status.load_more": "Kargañ muioc'h",
  "status.media.open": "Klikit evit digeriñ",
  "status.media.show": "Klikit evit diskouez",
  "status.media_hidden": "Media kuzhet",
  "status.mention": "Menegiñ @{name}",
  "status.more": "Muioc'h",
  "status.mute": "Kuzhat @{name}",
  "status.mute_conversation": "Kuzhat ar gaozeadenn",
  "status.open": "Digeriñ ar c'hannad-mañ",
  "status.pin": "Spilhennañ d'ar profil",
  "status.quote": "Menegiñ",
  "status.quote.cancel": "Nullañ ar menegiñ",
  "status.quote_error.limited_account_hint.action": "Diskouez memes tra",
  "status.quote_error.not_available": "Embannadur dihegerz",
  "status.quote_policy_change": "Cheñch piv a c'hall menegiñ",
  "status.read_more": "Lenn muioc'h",
  "status.reblog": "Skignañ",
  "status.reblog_or_quote": "Skignañ pe menegiñ",
  "status.reblog_private": "Skignañ d'hoc'h heulierien·ezed adarre",
  "status.reblogged_by": "Skignet gant {name}",
  "status.reblogs.empty": "Den ebet n'eus skignet ar c'hannad-mañ c'hoazh. Pa vo graet gant unan bennak e teuio war wel amañ.",
  "status.redraft": "Diverkañ ha skrivañ en-dro",
  "status.remove_bookmark": "Dilemel ar sined",
  "status.remove_favourite": "Dilemel eus ar re vuiañ-karet",
  "status.remove_quote": "Dilemel",
  "status.replied_to": "Respont da {name}",
  "status.reply": "Respont",
  "status.replyAll": "Respont d'ar gaozeadenn",
  "status.report": "Disklêriañ @{name}",
  "status.sensitive_warning": "Dalc'had kizidik",
  "status.share": "Rannañ",
  "status.show_less_all": "Diskouez nebeutoc'h evit an holl",
  "status.show_more_all": "Diskouez miuoc'h evit an holl",
  "status.show_original": "Diskouez hini orin",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Treiñ",
  "status.translated_from_with": "Troet diwar {lang} gant {provider}",
  "status.uncached_media_warning": "Rakwel n'eo ket da gaout",
  "status.unmute_conversation": "Diguzhat ar gaozeadenn",
  "status.unpin": "Dispilhennañ eus ar profil",
  "subscribed_languages.save": "Enrollañ ar cheñchamantoù",
  "subscribed_languages.target": "Cheñch ar yezhoù koumanantet evit {target}",
  "tabs_bar.home": "Degemer",
  "tabs_bar.menu": "Lañser",
  "tabs_bar.notifications": "Kemennoù",
  "tabs_bar.publish": "Embannadenn nevez",
  "tabs_bar.search": "Klask",
  "tag.remove": "Dilemel",
  "terms_of_service.title": "Divizoù implijout",
  "time_remaining.days": "{number, plural,one {# devezh} other {# a zevezh}} a chom",
  "time_remaining.hours": "{number, plural, one {# eurvezh} other{# eurvezh}} a chom",
  "time_remaining.minutes": "{number, plural, one {# munut} other{# a vunut}} a chom",
  "time_remaining.moments": "Pennadoù a-zilerc'h",
  "time_remaining.seconds": "{number, plural, one {# eilenn} other{# eilenn}} a chom",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Luskad ar mare",
  "ui.beforeunload": "Kollet e vo ho prell ma kuitit Mastodon.",
  "units.short.billion": "{count}miliard",
  "units.short.million": "{count}milion",
  "units.short.thousand": "{count}mil",
  "upload_area.title": "Tennañ ha leuskel evit pellgargañ",
  "upload_button.label": "Ouzhpennañ ur media",
  "upload_error.limit": "Bevenn evit pellgargañ restroù a zo distremenet.",
  "upload_error.poll": "Pellgargañ restroù n'eo ket aotreet gant sontadegoù.",
  "upload_form.edit": "Kemmañ",
  "upload_progress.label": "O pellgargañ...",
  "upload_progress.processing": "War ober…",
  "username.taken": "Tapet eo an anv implijer-mañ dija. Klaskit skrivañ unan all",
  "video.close": "Serriñ ar video",
  "video.download": "Pellgargañ ar restr",
  "video.exit_fullscreen": "Kuitaat ar mod skramm leun",
  "video.expand": "Ledanaat ar video",
  "video.fullscreen": "Skramm a-bezh",
  "video.hide": "Kuzhat ar video",
  "video.pause": "Paouez",
  "video.play": "Lenn",
  "visibility_modal.privacy_label": "Gwelusted",
  "visibility_modal.quote_followers": "Tud koumanantet hepken",
  "visibility_modal.quote_label": "Piv a c'hall menegiñ",
  "visibility_modal.quote_nobody": "Me hepken",
  "visibility_modal.quote_public": "Pep den",
  "visibility_modal.save": "Enrollañ"
}
